function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  id: "backgroundrect",
  width: "100%",
  height: "100%",
  x: 0,
  y: 0,
  fill: "none",
  stroke: "none"
});

var _ref3 = /*#__PURE__*/React.createElement("title", null, "Layer 1");

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M0,0 h24 v24 H0 z",
  id: "svg_1",
  className: ""
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fill: "#798637",
  d: "M9,16.2 L4.8,12 l-1.4,1.4 L9,19 L21,7 l-1.4,-1.4 L9,16.2 z",
  id: "svg_2",
  className: "selected",
  fillOpacity: 1
});

var SvgCheckMark = function SvgCheckMark(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    style: {},
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, /*#__PURE__*/React.createElement("g", {
    className: "currentLayer",
    style: {}
  }, _ref3, _ref4, _ref5));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCheckMark, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/check-mark.5d5b52ad.svg";
export { ForwardRef as ReactComponent };